import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { isMultiConfigProduct, isParentProduct } from '../../../utils/misc';

// Minimal shape of a serialized pricing-model product needed to pick a
// configuration route — products arrive as untyped JSON from the
// shoot_products payload, so only the routing-relevant fields are declared.
export interface LinkableProduct {
  id: number;
  is_voucher?: boolean;
  voucher_product_id?: number;
  product_type?: string;
  is_multi_config?: boolean;
}

// Mirrors CategoryProduct.jsx's voucher detection.
const isVoucher = (product: LinkableProduct): boolean =>
  product.is_voucher === true || product.product_type === 'voucher';

// Single source of truth for where a product tile navigates: vouchers go to
// the voucher flow, parent (YPX/BYO, non-multi-config) products go straight
// to the OrderRouter slot flow (mirrors Category.jsx's branching), and
// everything else goes to the regular product config route.
export const getProductLink = (product: LinkableProduct): string => {
  if (isVoucher(product)) {
    return `/v3/voucher-products/${product.voucher_product_id || product.id}`;
  }

  if (isParentProduct(product) && !isMultiConfigProduct(product)) {
    return `/v3/products/${product.id}/product/0#slots`;
  }

  return `/v3/products-regular/${product.id}`;
};

interface ProductLinkProps {
  product: LinkableProduct;
  children: ReactNode;
}

const ProductLink = ({ product, children }: ProductLinkProps) => (
  <Link to={getProductLink(product)}>{children}</Link>
);

export default ProductLink;
